import {QueryParamConfig} from '../../shared/models/query-param-config';
import {QueryParamName} from '../enums/query-param-name.enum';
import {ApplicationContextService} from '../services/impl/configuration/application-context.service';
import {DeviceService} from '../../shared/services/device.service';

export class QueryParamsConfig {

    static createParamsConfig(contextService: ApplicationContextService,
                              deviceService: DeviceService): QueryParamConfig[] {
        return [
            {
                paramName: QueryParamName.STEP_KEY,
                removeFromUrl: false
            },
            {
                paramName: QueryParamName.PROCESS_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.SESSION_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.OFFER_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.PARTNER,
                removeFromUrl: !contextService.contextDefined || !deviceService.isMobileDevice
            },
            {
                paramName: QueryParamName.SOURCE,
                removeFromUrl: !contextService.contextDefined || !deviceService.isMobileDevice
            },
            {
                paramName: QueryParamName.TEST,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.ORIGIN,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.LOGGED_USER_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.OPEN_AZTEC_SCANNER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.PARTNER_EXTERNAL_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.AZTEC_ENCODED,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.SKIP_TO_STEP,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.USER_PAYLOAD,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.SESSION_STAGE,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.CONTEXT,
                removeFromUrl: !contextService.contextDefined || !deviceService.isMobileDevice
            },
            {
                paramName: QueryParamName.PARTNER_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.USER_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.DEVICE_SERIAL_NUMBER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.LOGO_REDIRECT_DISABLED,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.APPLICATION_ID,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.TESTING_PRESETS,
                removeFromUrl: false
            },
            {
                paramName: QueryParamName.IS_GAS_INSTALLATION,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.IS_ABROAD,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.VEHICLE_CONDITION,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.CONDITION,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.YOUNGEST_DRIVER_AGE,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.EMAIL,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.PHONE_NUMBER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.MAKE,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.BRAND_NAME,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.YEAR,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.ACTUAL_MILEAGE,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.VIN,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.MODEL,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.FUEL,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.REGISTRATION_NUMBER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.FIRST_NAME,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.LAST_NAME,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.POSTAL_CODE,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.PESEL,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.CITY,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.STREET,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.BUILDING_NUMBER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.FLAT_NUMBER,
                removeFromUrl: true
            },
            {
                paramName: QueryParamName.CONTEXT_ID,
                removeFromUrl: true
            }
        ];
    }
}
